<div class="modal-header">
  <h3 class="modal-title" i18n="@@quoteHeader" id="quote-modal-header">Quote Viewer</h3>
  <button
    type="button"
    class="close"
    i18n-aria-label
    aria-label="Close Quote"
    ngbAutoFocus
    [disabled]="saving"
    (click)="close()"
    (keydown.enter)="close()"
    (keydown.space)="close()"
    aria-describedby=""
  >
    <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
  </button>
</div>
<div class="modal-body" id="quote-details">
  @if (loading) {
    <div class="relative-container loading-container" aria-live="polite">
      <span><i class="button_spinner input-loading-spinner-left"></i> Loading quote...</span>
    </div>
  }
  @if (saving) {
    <div class="relative-container loading-container" aria-live="polite">
      <span><i class="button_spinner input-loading-spinner-left"></i> Changing Ownership...</span>
    </div>
  }
  @if (!loading && !saving) {
    <div [innerHtml]="quote?.generatedHtml | safeHtml: 'html'"></div>
  }
  @if (!loading && !saving) {
    <div class="message-container">
      <label for="quote-message" i18n="@@quoteModalMessage"><strong>Message:</strong></label
      ><br />
      <textarea
        id="quote-message"
        cols="74"
        rows="5"
        maxlength="1000"
        [(ngModel)]="note"
      ></textarea>
    </div>
  }
</div>
<div class="modal-footer">
  <div
    class="relative-container flex-row-container"
    style="justify-content: space-between; width: 100%"
  >
    @if (ownerId !== invokedUserId) {
      <button
        type="button"
        id="button_ochange"
        appButton="small"
        aria-label="Close"
        i18n-aria-label
        [disabled]="loading || saving"
        (click)="changeOwnership()"
        (keydown.enter)="changeOwnership()"
        (keydown.space)="changeOwnership()"
      >
        <span i18n="@@quoteEmailQuote">Email Quote to Traveller</span>
      </button>
    }
    @if (ownerId === invokedUserId) {
      <button
        type="button"
        id="button_resend"
        appButton="small"
        aria-label="Close"
        i18n-aria-label
        [disabled]="loading || saving"
        (click)="resendEmail()"
        (keydown.enter)="resendEmail()"
        (keydown.space)="resendEmail()"
      >
        <span i18n="@@quoteSendEmail">Send Email</span>
      </button>
    }
    <button
      type="button"
      id="button_ok"
      appButton="small"
      aria-label="Close"
      i18n-aria-label
      [disabled]="saving"
      (click)="close()"
      i18n="@@suppclose"
    >
      <span>Close</span>
    </button>
  </div>
</div>
